export const FLAG_GETTING_CUSTOMER = "FLAG_GETTING_CUSTOMER";
export const GET_CUSTOMER = "GET_CUSTOMER";
export const CLEAR_CUSTOMER = "CLEAR_CUSTOMER";
